import check from "./check";
import shieldEmpty from "./shieldEmpty";

export const shield = {
  "shield/check": check,
  "shield/empty": shieldEmpty,
};
